module.exports = __webpack_public_path__ + "img/notshop.c02ee61d.png";